import { useState } from 'react'

import { Button, ChevronDownIcon, DropdownMenu } from '@buffer-mono/popcorn'

import styles from './SearchImages.module.css'

const ORIENTATIONS = [
  { id: 0, label: 'Any orientation', value: '' },
  { id: 1, label: 'Landscape', value: 'landscape' },
  { id: 2, label: 'Portrait', value: 'portrait' },
  { id: 3, label: 'Square', value: 'squarish' },
]

type Orientation = (typeof ORIENTATIONS)[number]

type OrientationDropdownMenuProps = {
  onChangeOrientation: (orientation: string) => void
}

/**
 *  COMPONENT: ORIENTATION DROPDOWN MENU
 */
export const OrientationDropdownMenu = ({
  onChangeOrientation,
}: OrientationDropdownMenuProps): JSX.Element => {
  const [selectedOrientationLabel, setSelectedOrientationLabel] = useState(
    ORIENTATIONS[0].label,
  )

  const handleOrientationChange = (orientation: Orientation): void => {
    onChangeOrientation(orientation.value)
    setSelectedOrientationLabel(orientation.label)
  }

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <Button variant="tertiary" className={styles.orientationTrigger}>
          {selectedOrientationLabel} <ChevronDownIcon />
        </Button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content align="start">
        {ORIENTATIONS.map((orientation) => (
          <DropdownMenu.CheckboxItem
            onSelect={() => handleOrientationChange(orientation)}
            key={orientation.id}
            checked={selectedOrientationLabel === orientation.label}
          >
            {orientation.label}
          </DropdownMenu.CheckboxItem>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  )
}
